import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const AuthButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledAuthButton = styled.button`
  background: linear-gradient(135deg, #4a90e2 0%, #357ae8 100%);
  color: white;
  border: none;
  border-radius: 16px;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(74, 144, 226, 0.2);
  position: relative;
  overflow: hidden;
  min-width: 60px;
  padding-left: 12px;
  padding-right: 12px;
  &:hover {
    background: linear-gradient(135deg, #357ae8 0%, #2968d4 100%);
    box-shadow: 0 4px 8px rgba(74, 144, 226, 0.3);
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.3), 0 4px 8px rgba(74, 144, 226, 0.3);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(74, 144, 226, 0.2);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }

  &:hover::before {
    left: 100%;
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #333;
`;

const Avatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 10px;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
`;

interface AuthButtonProps {
  onOpenModal: () => void;
}

const AuthButton: React.FC<AuthButtonProps> = ({ onOpenModal }) => {
  const { t } = useTranslation();
  const { user, loading, signOut } = useAuth();

  // 获取用户名首字母或邮箱首字母作为头像显示
  const getInitials = () => {
    if (!user) return '?';
    
    const name = user.user_metadata?.full_name || user.email;
    return name ? name.charAt(0).toUpperCase() : '?';
  };

  if (loading) {
    return null; // 加载时不显示任何内容
  }

  return (
    <AuthButtonContainer>
      {user ? (
        <>
          {/* <UserInfo>
            <Avatar>{getInitials()}</Avatar>
          </UserInfo> */}
          <StyledAuthButton onClick={signOut}>
            {t('auth.logout')}
          </StyledAuthButton>
        </>
      ) : (
        <StyledAuthButton onClick={onOpenModal}>
          {t('auth.login')}
        </StyledAuthButton>
      )}
    </AuthButtonContainer>
  );
};

export default AuthButton; 